<template>
  <div class="full-screen">
    <header>
      <a href="/" class="logo">悦动网络</a>
    </header>
    <slot name="main"></slot>
    <footer style="width: 100%;font-size: 12px;text-align: center; padding: 20px 0; margin-top: 20px;border-top: 1px solid #efefef;">
      <a style="color: #aaaaaa" target="_blank" href="http://beian.miit.gov.cn/">蜀ICP备17032491号-2</a>
    </footer>
  </div>
</template>
<script>
  export default {
    'name': 'layout-account'
  }
</script>
<style lang="less">
  @import "~ant-design-vue/es/style/themes/default";
  @import "../assets/style/common";

  .full-screen {
    min-height: 100%;
    background: @background-color-base;

    header {
      height: 50px;
      background: @body-background;
      line-height: 50px;

      a.logo {
        margin-left: 20px;
        display: inline-block;
        height: 50px;
        background: url("../assets/img/logo/logo-label.png") no-repeat left center;
        background-size: contain;
        width: 130px;
        text-indent: -9999px;
      }

      .drop-shadow();
    }
  }
</style>
